//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    baseSku: { type: String, required: true },
    quotes: { type: Array, required: true }
  },
  computed: {
    visibleQuotes () {
      return this.quotes.map(quote => ({
        ...quote,
        image: quote.image.url
      }))
    }
  }
}
